/* eslint-disable no-param-reassign */
window.TV2 = window.TV2 || {};

window.TV2.showModalImageAsync = (clickedImage, imageAlt, aspect) => {
  const resourcePromises = ['photoswipe-ui-default.min.js', 'photoswipe.min.js'].map((name) =>
    TV2.appendScriptIfNotExist({ src: `${window.TV2.cdnResources.external}/${name}` }),
  );
  Promise.all(resourcePromises).then(() => window.TV2.ModalImage(clickedImage, imageAlt, aspect));
};

window.TV2.ModalImage = (clickedImage, imageAlt, aspect) => {
  const pswpRoot = document.createElement('div');
  pswpRoot.classList.add('pswp');
  pswpRoot.innerHTML = `
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="Lukk"></button>
          <button class="pswp__button pswp__button--zoom" title="Zoom inn/ut"></button>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(pswpRoot);

  if (pswpRoot) {
    // Photoswipe docs: http://photoswipe.com/documentation/api.html

    const ratio = aspect || 0.42;
    const medium = {
      width: 1920,
      height: Math.floor(1920 * ratio),
    };
    const big = {
      width: 2048,
      height: Math.floor(2048 * ratio),
    };

    if (ratio > 1) {
      medium.width = Math.floor(1920 / ratio);
      medium.height = 1920;

      big.width = Math.floor(2048 / ratio);
      big.height = 2048;
    }

    const mediumUrl = clickedImage
      .replace(/width=(\d+)/, `width=${medium.width}`)
      .replace(/height=(\d+)/, `height=${medium.height}`);

    const bigUrl = clickedImage
      .replace(/width=(\d+)/, `width=${big.width}`)
      .replace(/height=(\d+)/, `height=${big.height}`);

    const items = [
      {
        title: unescape(imageAlt),
        mediumImage: {
          src: mediumUrl,
          w: medium.width,
          h: medium.height,
        },
        originalImage: {
          src: bigUrl,
          w: big.width,
          h: big.height,
        },
      },
    ];

    const options = {
      index: 0,
    };

    const pswp = new PhotoSwipe(pswpRoot, PhotoSwipeUI_Default, items, options);

    let realViewportWidth;
    let useLargeImages = false;
    let firstResize = true;
    let imageSrcWillChange;

    pswp.listen('beforeResize', () => {
      realViewportWidth = pswp.viewportSize.x * window.devicePixelRatio;

      if (useLargeImages && realViewportWidth < 1000) {
        useLargeImages = false;
        imageSrcWillChange = true;
      } else if (!useLargeImages && realViewportWidth >= 1000) {
        useLargeImages = true;
        imageSrcWillChange = true;
      }

      imageSrcWillChange && !firstResize && pswp.invalidateCurrItems();

      if (firstResize) {
        firstResize = false;
      }

      imageSrcWillChange = false;
    });

    pswp.listen('gettingData', (index, item) => {
      if (useLargeImages) {
        item.src = item.originalImage.src;
        item.w = item.originalImage.w;
        item.h = item.originalImage.h;
      } else {
        item.src = item.mediumImage.src;
        item.w = item.mediumImage.w;
        item.h = item.mediumImage.h;
      }
    });

    pswp.listen('destroy', () => pswpRoot.remove());

    pswp.init();
  }
};
